<!-- 品名管理编辑-->
<template>
    <el-form ref="form" label-width="100px" style="margin:0 20px">
        <el-row>
            <el-col :xs="24" :sm="18">
                <el-form-item :label="msg('类型')">
                    <el-radio v-model="open" :label="0">公共</el-radio>
                    <el-radio v-model="open" :label="1">私有</el-radio>
                </el-form-item>
            </el-col>
        </el-row>
        <div style="text-align:center; margin-top: 15px;">
            <el-button type="primary" size="mini"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('确认')}}</span></el-button>
            <el-button  size="mini" v-on:click="$emit('close-dg')">{{msg('取消')}}</el-button>
        </div>

    </el-form>

</template>

<script>
export default {
    name: "productNameEdit",
    components:{

    },
    data(){
        return {
            ids:[],
            open:null,
        }
    },
    mounted(){
    },
    props:{
    },
    methods:{
        init(ids){
            this.ids = ids;
            this.open = null
        },
        onSubmit(){
            var _this = this;

            if(!this.open && this.open != 0){
                this.$message(this.msg('请选择类型'));
                return;
            }

            var url = this.$kit.api.simpleProductName.updateType;

            this.$axios.post(url+'?t='+this.open,this.ids)
                .then(function(result){
                    _this.$message(result.data || _this.msg('update-ok'));
                    _this.$emit("close-dg", true);
                });
        },
    }

}
</script>

<style lang="scss" scoped>

</style>